import { render, staticRenderFns } from "./TravellerSummary.vue?vue&type=template&id=01f9fe2c&"
import script from "./TravellerSummary.vue?vue&type=script&lang=js&"
export * from "./TravellerSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports